<ion-content>
  <ion-list>
    <ion-item *ngIf="comment?.employeeId == employeeId" button translate (click)="deleteComment()">news.comment.popover.delete</ion-item>
    <ion-item *ngIf="comment?.employeeId !== employeeId" button translate (click)="reportComment()">news.comment.popover.report</ion-item>
    <ion-item *ngIf="comment?.employeeId == employeeId" button translate (click)="editComment()">news.comment.popover.edit</ion-item>
  </ion-list>
</ion-content>
